import React from "react";
import styles from "./VideoCard.module.scss";

export const VideoCard = ({ video }) => {
  const { videoUrl, fileName, thumbnail } = video;

  const handlePlay = () => {
    if (videoUrl) window.open(videoUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className={styles.video_card} role="button" tabIndex={0} onClick={handlePlay} onKeyDown={(e) => e.key === "Enter" && handlePlay()}>
      <div className={styles.video_thumb}>
        {thumbnail ? <img src={thumbnail} alt={fileName || "Video thumbnail"} /> : <span data-testid="video-thumb-fallback" className={styles.video_thumb_fallback} />}
        <span className={styles.video_play_icon} aria-hidden="true">
          <i className="fa fa-play fa-lg" aria-hidden="true"></i>
        </span>
      </div>
      <span className={styles.video_name}>{fileName || "Watch video"}</span>
    </div>
  );
};
